<template>
	<div>
		<EbHeading level="h1" class="eb-page-heading eb-upper-title">Première connexion</EbHeading>
		
		<router-link :to="{name: 'login'}" class="block text-left back-link"><font-awesome-icon :icon="['fas', 'chevron-left']" class="mr-5" />Retour au formulaire de connexion</router-link>
		
		
		<div v-if="page === 'waitForApproval'">
			<EbBanner type="waiting" title="Activation de votre compte en attente" :timestamp="bannerTimestamp">
				Merci de vérifier le contenu de votre boîte mail. <strong>{{ courriel }}</strong>
			</EbBanner>
			
			<div class="text-left">
				<p>
					<strong>Un courriel de confirmation a été envoyé à l'adresse {{ courriel }}. Suivez les indications pour confirmer l’activation de votre compte.</strong>
				</p>
				<p>Si vous ne trouvez pas le courriel, vérifiez dans vos messages indésirables (spam).</p>
				<p>En cas d’erreur de saisie de mail, identifiez-vous avec vos identifiants qui vous avaient été adressés par courrier, pour recommencer cette étape.</p>
			</div>
		</div>
		<div v-else>
			
			<EbBanner :isActive="isBannerActive" :type="bannerType" :timestamp="bannerTimestamp">{{bannerContent}}</EbBanner>
			
			<form action="#" @submit.prevent="compareChangingPasswords() && submitForm()">
				<EbInput v-model="username" label="Nom d’utilisateur" width="expand" readonly></EbInput>
				
				<EbInput v-model="codeActivation" label="Code d’activation" width="expand" readonly></EbInput>
				
				<EbInput type="email" v-model="email" label="Votre courriel" required width="expand"></EbInput>
				
				<EbPassword v-model="password" required label="Nouveau mot de passe" needCondition width="expand"></EbPassword>
				
				<EbButton type="submit" expanded="expanded" site-color="site-color">Enregistrer</EbButton>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	name: "FirstConnection",
	props: {
		username: {
			type: String,
			default: "",
		},
		codeActivation: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			page: null,
			error: false,
			passwordError: false,
			email: "",
			password: "",
			isBannerActive: false,
			bannerTitle: null,
			bannerTimestamp: null,
			bannerType: null,
			bannerContent: ''
		}
	},
	methods: {
		showError: function(val) {
			this.passwordError = val
		},
		compareChangingPasswords: function() {
			this.isBannerActive = false
			
			if(this.codeActivation !== this.password) {
				return true
			}
			
			this.isBannerActive = true
			this.bannerTimestamp = this.getTime()
			this.bannerType = 'error'
			this.bannerContent = 'Les champs "Code d’activation" et "Nouveau mot de passe" doivent être différents, veuillez vérifier votre saisie.'
			return false
		},
		submitForm: async function() {
			this.isBannerActive = false
			await this.$http
			.post("authentification/activationCompte", {
				codeActivation: this.codeActivation,
				email: this.email,
				password: this.password,
				username: this.username,
			})
			.then(resp => {
				this.page = "waitForApproval"
			})
			.catch(error => {
				this.isBannerActive = true
				this.bannerTimestamp = this.getTime()
				this.bannerType = 'error'
				this.bannerContent = 'Une erreur est survenue lors de la prise en compte de votre demande par le serveur, veuillez vérifier votre saisie.'
			})
		},
	},
}
</script>
